import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { TdsCheckbox } from '@scania/tegel-react'
import {
  CheckboxRow,
  StyledDivider,
  Title
} from './point-compliant-card.styles'
import type { PointCompliantCardProps } from './point-compliant-card.types'

export function PointCompliantCard({
  compliant,
  onCompliantChange,
  disabled = false
}: PointCompliantCardProps) {
  const { t } = useTranslation('common')

  const onYesChange = useCallback(() => {
    if (compliant === true) {
      onCompliantChange(null)
    } else {
      onCompliantChange(true)
    }
  }, [onCompliantChange, compliant])

  const onNoChange = useCallback(() => {
    if (compliant === false) {
      onCompliantChange(null)
    } else {
      onCompliantChange(false)
    }
  }, [onCompliantChange, compliant])

  return (
    <>
      <StyledDivider variant='discrete' />
      <Title>{t('compliant')}</Title>
      <CheckboxRow>
        <TdsCheckbox
          onTdsChange={onYesChange}
          checked={compliant === true}
          disabled={disabled}
        >
          {t('yes')}
        </TdsCheckbox>
        <TdsCheckbox
          onTdsChange={onNoChange}
          checked={compliant === false}
          disabled={disabled}
        >
          {t('no')}
        </TdsCheckbox>
      </CheckboxRow>
    </>
  )
}
